
import DigitalOnboardingService from "../services/api/digitalOnboardingService";

export const getFiles = async () => {

    let headers = {
        'idCredit': 0
    };

    var PromiseGetDocuments = new DigitalOnboardingService().getDocument("666", "1", headers);
    PromiseGetDocuments.then(function (response) {
        console.log("Response get Documents")
        console.log(response);
    });


};

export const sendExcpetions = async (uiid, flagExpetion) => {

    let headers = {
        'flagTypeError' : flagExpetion,
        'Authorization' : "Basic d2ViOjU3M089MmwlMVY1V2xkKmptVCUqSipDdQ=="
    };

    var PromiseSendException = new DigitalOnboardingService().sendExceptionNobarium(uiid, headers);
    PromiseSendException.then(function (response) {
        console.log("Response send Expection")
        console.log(response);
    });

}